module.exports = __webpack_public_path__ + "img/tree-05-d-leaves.1f4e8ba8.png";